module.exports = "/_next/static/images/icon-vc-f32f6cf5.png";